import {AxiosError} from 'axios';
import {GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutSpecialConsideration = ({uuid, onSuccess, onError}: Input) => {
  const putSpecialConsideration = async () => {
    await axiosClient.put(GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_URL(uuid));
  };

  return useCustomMutation(putSpecialConsideration, {
    onSuccess,
    onError,
  });
};
